var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Placeholder",class:_vm.getClass(),attrs:{"data-node-id":_vm.node.id,"data-node-name":_vm.node.name}},[_c('div',{staticClass:"Placeholder-delete",on:{"click":_vm.handleDeleteBtnClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }